// extracted by mini-css-extract-plugin
export default {"chip":"CustomChip_chip__ldcg8","chipLabels":"CustomChip_chipLabels__WbUcg","customChipCls":"CustomChip_customChipCls__mefrs"};